<div class="mb-4">
  <strong class="fs-3">Suivi de consommation</strong>
</div>

<admin-export-consumption-tracking-form></admin-export-consumption-tracking-form>
